import {SweetError} from 'app/utils/errors';

let sentryInstalled = window.Sentry != null;

interface ExtraType {
  [key: string]: unknown;
}

export function setSentryInstalled(installed: boolean): void {
  sentryInstalled = installed;
}

export function isSentryInstalled(): boolean {
  return sentryInstalled;
}

export const sendSentryError = (
  ...args: Parameters<typeof window.Sentry.captureException>
): void => {
  isSentryInstalled() && window.Sentry.captureException(...args);
};

export const sendSentryMessage = (
  ...args: Parameters<typeof window.Sentry.captureMessage>
): void => {
  isSentryInstalled() && window.Sentry.captureMessage(...args);
};

export const sendSentryReportDialog = (
  ...args: Parameters<typeof window.Sentry.showReportDialog>
): void => {
  isSentryInstalled() && window.Sentry.showReportDialog(...args);
};

export const withSentryScope = (
  ...args: Parameters<typeof window.Sentry.withScope>
): void => {
  isSentryInstalled() && window.Sentry.withScope(...args);
};

export function configureSentryScope(
  ...args: Parameters<typeof window.Sentry.configureScope>
): void {
  isSentryInstalled() && window.Sentry.configureScope(...args);
}

export function reportToSentry(
  error: string | SweetError | Error | Record<string, unknown>,
  extra?: ExtraType,
  hideError?: boolean,
  level: 'info' | 'fatal' | 'error' | 'warning' = 'error'
): void {
  const detail =
    typeof error === 'string'
      ? error
      : 'detail' in error
      ? error.detail
      : error;

  const reason: any = detail.reason || detail;

  if (extra && (extra.status === 404 || extra.status === 403)) {
    // ignore 404 errors and 403
    return;
  }

  withSentryScope((scope) => {
    scope.setLevel(level);
    Object.keys(extra || {}).forEach((key) =>
      scope.setExtra(key, (extra || {})[key])
    );
    reason.response
      ? sendSentryMessage(reason.message)
      : sendSentryError(reason);
  });

  if (!hideError) {
    throw error;
  }
}
